import type { IDashboardTemplate } from "../types";
import { EFamilyTypes } from "../components/DashboardTemplatesTypes";
import { AssetsService } from "../../../../services/AssetsService";
import { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

const FAMILY = "Industry";

const dashboard: IDashboardTemplate = {
    id: 16,
    title: "dashboard.templates.marketshare.title",
    description: "dashboard.templates.marketshare.description",
    descriptionLong: "dashboard.templates.marketshare.description.long",
    keyMetrics: "dashboard.templates.marketshare.keymetric",
    previewImage: AssetsService.assetUrl("/images/dashboard/templates/MarketShare-preview.png"),
    thumbnailImage: AssetsService.assetUrl("/images/dashboard/templates/MarketShare-thumb.png"),
    familyType: EFamilyTypes.Categories,
    autoFillIndustries: true,
    minItems: 1,
    maxItems: 1,
    isNew: true,
    widgets: [
        {
            singleModeOnly: true,
            pos: {
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                sizeX: 4,
                row: 0,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "TopCategoryShare",
                webSource: devicesTypes.TOTAL,
                duration: BasicDurations.LAST_THREE_MONTHS,
                type: "CategoryShareGraphDashboard",
                filters: {
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: FAMILY,
                options: {},
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "TopSitesExtended",
                webSource: devicesTypes.TOTAL,
                duration: BasicDurations.LAST_THREE_MONTHS,
                type: "TopSitesTable",
                filters: {
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                    orderBy: "Share desc",
                },
                width: "2",
                customAsset: false,
                family: FAMILY,
                options: {},
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "CategoryLeadersSearch",
                webSource: devicesTypes.DESKTOP,
                duration: BasicDurations.LAST_MONTH,
                type: "LeaderBySourceTable",
                filters: {
                    includeSubDomains: "true",
                    orderBy: "Share desc",
                },
                width: "2",
                customAsset: false,
                family: FAMILY,
                options: {},
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "CategoryLeadersSocial",
                webSource: devicesTypes.DESKTOP,
                duration: BasicDurations.LAST_MONTH,
                type: "LeaderBySourceTable",
                filters: {
                    includeSubDomains: "true",
                    orderBy: "Share desc",
                },
                width: "2",
                customAsset: false,
                family: FAMILY,
                options: {},
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 3,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "CategoryLeadersAds",
                webSource: devicesTypes.DESKTOP,
                duration: BasicDurations.LAST_MONTH,
                type: "LeaderBySourceTable",
                filters: {
                    includeSubDomains: "true",
                    orderBy: "Share desc",
                },
                width: "2",
                customAsset: false,
                family: FAMILY,
                options: {},
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 3,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "CategoryLeadersReferrals",
                webSource: devicesTypes.DESKTOP,
                duration: BasicDurations.LAST_MONTH,
                type: "LeaderBySourceTable",
                filters: {
                    includeSubDomains: "true",
                    orderBy: "Share desc",
                },
                width: "2",
                customAsset: false,
                family: FAMILY,
                options: {},
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 4,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "CategoryLeadersDirect",
                webSource: devicesTypes.DESKTOP,
                duration: BasicDurations.LAST_MONTH,
                type: "LeaderBySourceTable",
                filters: {
                    includeSubDomains: "true",
                    orderBy: "Share desc",
                },
                width: "2",
                customAsset: false,
                family: FAMILY,
                options: {},
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 4,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "CategoryLeadersMail",
                webSource: devicesTypes.DESKTOP,
                duration: BasicDurations.LAST_MONTH,
                type: "LeaderBySourceTable",
                filters: {
                    includeSubDomains: "true",
                    orderBy: "Share desc",
                },
                width: "2",
                customAsset: false,
                family: FAMILY,
                options: {},
            },
        },
    ],
};

export default dashboard;
